﻿import React, { useEffect, useState } from 'react';
import { FormDateInput, FormTextInput } from 'components/form-fields';
import moment from "moment";
import { useValidation } from "hooks/useValidation";
import PropTypes from 'prop-types';
import { ReoccurrenceSettings } from 'components/settings';

export function ScheduleReoccurrenceSettings(
    {
        disabled = false,
        allowWeeklyRepeating = false,
        editing = false,
        loading,
        onScheduleUpdate,
        onValidationUpdate,
        schedule
    }
) {

    const [isValid, errors, validate] = useValidation();
    const [reoccurrenceValid, setReoccurrenceValid] = useState(false);
    const maxMonthsInPast = 6;
    const maxMonthsInFuture = 12;

    useEffect(onValidationChange, [isValid, reoccurrenceValid]);

    function onValidationChange() {
        onValidationUpdate(isValid && reoccurrenceValid);
    }

    useEffect(updateValidationRules, [schedule]);

    function updateValidationRules() {
        const rules = [
            { fieldName: "name", required: true },
            { fieldName: "startDate", required: true, type: "date" },
        ];

        validate(rules, schedule, []);
    }

    function onReoccurrenceValidationUpdate(isReoccurrenceValid) {
        setReoccurrenceValid(isReoccurrenceValid);
    }

    function onNameChange(event) {
        onScheduleUpdate({
            ...schedule,
            name: event.target.value
        });
    }

    function onStartDateChange(item) {
        onScheduleUpdate({
            ...schedule,
            startDate: item ? moment(item).utc().format("YYYY-MM-DD HH:mm") : null
        });
    }

    function onReoccurrenceChange(item) {
        onScheduleUpdate({
            ...schedule,
            reoccurrenceSettings: item
        });
    }

    return (
        <div>
            <h2>Schedule Settings</h2>
            <FormTextInput
                id="schedule-name"
                loading={loading}
                value={schedule.name}
                headingText="Schedule title:"
                onChange={onNameChange}
                dangerHelperText={errors.name}
                disabled={disabled}
            />
            <FormDateInput
                id="schedule-start-date"
                headingText="When would you like your schedule to start?"
                onChange={onStartDateChange}
                value={schedule.startDate}
                loading={loading}
                minDate={(disabled || editing) ? null : moment().subtract(maxMonthsInPast, 'M').startOf('day').toDate()}
                maxDate={(disabled || editing) ? null : moment().add(maxMonthsInFuture, 'M').toDate()}
                dangerHelperText={errors.startDate}
                includeTime={true}
                disabled={disabled || editing}
            />
            <ReoccurrenceSettings
                allowWeeklyRepeating={allowWeeklyRepeating}
                loading={loading}
                reoccurrenceSettings={schedule.reoccurrenceSettings}
                onReoccurrenceUpdate={onReoccurrenceChange}
                onValidationUpdate={onReoccurrenceValidationUpdate}
                startDate={schedule.startDate}
                disabled={disabled || editing}
            ></ReoccurrenceSettings>
        </div>
    );
}

ScheduleReoccurrenceSettings.propTypes = {
    disabled: PropTypes.bool,
    allowWeeklyRepeating: PropTypes.bool,
    onValidationUpdate: PropTypes.func.isRequired,
    onScheduleUpdate: PropTypes.func.isRequired,
    schedule: PropTypes.object.isRequired,
    editing: PropTypes.bool
};